(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1385],{

/***/ 21385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProductSizeGuide; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51526);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57891);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14408);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37444);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _components_Navigation_NavigationBanner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64061);
/* harmony import */ var _components_UI_Icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54678);
/* harmony import */ var _components_UI_RichText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55071);
/* harmony import */ var _components_UI_Table__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27915);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60118);
/* harmony import */ var _hooks_useBodyScrollLock__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38230);
/* harmony import */ var _hooks_useINPTrick__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20462);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60540);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_14__);


















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default()));
function ProductSizeGuide(param) {
    var className = param.className, table = param.table, wysiwyg = param.wysiwyg, isSizeGuideVisible = param.isSizeGuideVisible, onClose = param.onClose;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_components_Navigation_NavigationBanner__WEBPACK_IMPORTED_MODULE_6__/* .useNavBannerContext */ .DI)(), 1), isVisible = ref[0];
    var ref1 = (0,_hooks_useINPTrick__WEBPACK_IMPORTED_MODULE_12__/* .useINPTrick */ .z)(), onInteract = ref1.onInteract, hasInteracted = ref1.hasInteracted;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_10__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var richTextStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_10__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.RichTextEditorial */ .C.RichTextEditorial
    });
    (0,_hooks_useBodyScrollLock__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(isSizeGuideVisible);
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().ProductSizeGuide), className, {
            isBannerVisible: isVisible,
            isVisible: isSizeGuideVisible,
            hasInteracted: hasInteracted
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .AnimatePresence */ .M, {
            children: isSizeGuideVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().children),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_17__.m.div, {
                            initial: {
                                y: "-100%",
                                opacity: 0
                            },
                            animate: {
                                y: "0%",
                                opacity: 1
                            },
                            exit: {
                                y: "-100%",
                                opacity: 0
                            },
                            transition: {
                                duration: 0.6
                            },
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().wrapper), gridStyle),
                            children: [
                                table && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Table__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().table),
                                    hasDifferentLayoutInDesktop: true
                                }, table)),
                                wysiwyg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().wysiwyg), richTextStyle),
                                    render: wysiwyg
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().closeIcon),
                                    onClick: function(e) {
                                        return onInteract(function() {
                                            return onClose(e);
                                        });
                                    },
                                    "aria-label": (ref2 = t(_data_dictionary__WEBPACK_IMPORTED_MODULE_13__/* .CTA.CLOSE */ .MV.CLOSE)) !== null && ref2 !== void 0 ? ref2 : "close",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Icons__WEBPACK_IMPORTED_MODULE_7__/* .BigCloseIcon */ .R1, {
                                        theme: _types_colors__WEBPACK_IMPORTED_MODULE_3__/* .GlobalThemeColors.White */ .b.White,
                                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().icon))
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_17__.m.div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            duration: 0.8
                        },
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().background), {
                            isOpen: isSizeGuideVisible
                        }),
                        onClick: function(e) {
                            return onInteract(function() {
                                return onClose(e);
                            });
                        }
                    }, "animation-bg")
                ]
            })
        })
    });
}


/***/ }),

/***/ 27915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Table; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/Abstracts/Table/styles.module.scss
var styles_module = __webpack_require__(13717);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Table/index.tsx




var cx = bind_default().bind((styles_module_default()));
function Table(param) {
    var className = param.className, thead = param.thead, tbody = param.tbody, hasDifferentLayoutInDesktop = param.hasDifferentLayoutInDesktop, combinedTbody = param.combinedTbody, theadClassName = param.theadClassName, tbodyClassName = param.tbodyClassName, desktopTbodyClassName = param.desktopTbodyClassName, firstColumnDesktopClassName = param.firstColumnDesktopClassName;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: cx((styles_module_default()).Table, className),
        children: [
            thead && /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                className: cx((styles_module_default()).thead, theadClassName, hasDifferentLayoutInDesktop ? (styles_module_default()).hideOnLargeScreen : null),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: thead === null || thead === void 0 ? void 0 : (ref = thead.values) === null || ref === void 0 ? void 0 : ref.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: value
                        }, "thead_td_".concat(index));
                    })
                })
            }),
            tbody && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                className: cx((styles_module_default()).tbody, tbodyClassName, hasDifferentLayoutInDesktop ? (styles_module_default()).hideOnLargeScreen : null),
                children: tbody === null || tbody === void 0 ? void 0 : tbody.map(function(row, rowIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                        children: row === null || row === void 0 ? void 0 : (ref = row.values) === null || ref === void 0 ? void 0 : ref.map(function(value, columnIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: value
                            }, "tbody_tr_".concat(rowIndex, "_td_").concat(columnIndex));
                        })
                    }, "tbody_tr_".concat(rowIndex));
                })
            }),
            hasDifferentLayoutInDesktop && combinedTbody && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                className: cx((styles_module_default()).tbodyDesktop, desktopTbodyClassName, (styles_module_default()).hideOnSmallScreen),
                children: combinedTbody === null || combinedTbody === void 0 ? void 0 : combinedTbody.map(function(row, rowIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                        children: row === null || row === void 0 ? void 0 : (ref = row.values) === null || ref === void 0 ? void 0 : ref.map(function(value, columnIndex) {
                            var isFirstColumn = columnIndex === 0;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                className: isFirstColumn ? cx((styles_module_default()).isFirst, firstColumnDesktopClassName) : null,
                                children: value
                            }, "tbody_tr_desktop_".concat(rowIndex, "_td_").concat(columnIndex));
                        })
                    }, "tbody_tr_desktop_".concat(rowIndex));
                })
            })
        ]
    });
}
Table.defaultProps = {};
/* harmony default export */ var Abstracts_Table = (Table);

// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/Table/styles.module.scss
var Table_styles_module = __webpack_require__(20061);
var Table_styles_module_default = /*#__PURE__*/__webpack_require__.n(Table_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Table/index.tsx










var Table_cx = bind_default().bind((Table_styles_module_default()));
function Table_Table(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var tableStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var labelsStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Table, (0,_object_spread/* default */.Z)({
        className: Table_cx((Table_styles_module_default()).Table, className, tableStyle),
        theadClassName: Table_cx((Table_styles_module_default()).thead, labelsStyle),
        tbodyClassName: (Table_styles_module_default()).tbody,
        desktopTbodyClassName: (Table_styles_module_default()).tbodyDesktop,
        firstColumnDesktopClassName: Table_cx((Table_styles_module_default()).firstColumnDesktop, labelsStyle)
    }, rest));
}
Table_Table.defaultProps = {};
/* harmony default export */ var UI_Table = (Table_Table);


/***/ }),

/***/ 13717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__zNkcK","hideOnSmallScreen":"styles_hideOnSmallScreen__XYFkC","hideOnLargeScreen":"styles_hideOnLargeScreen__meEsb"};

/***/ }),

/***/ 60540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductSizeGuide":"styles_ProductSizeGuide__L7SLD","hasInteracted":"styles_hasInteracted__7r4BS","isVisible":"styles_isVisible__dhDY_","isBannerVisible":"styles_isBannerVisible__2CpIJ","wrapper":"styles_wrapper__jGeR_","children":"styles_children__Dlj4_","wysiwyg":"styles_wysiwyg__kgGur","table":"styles_table__hc4_6","closeIcon":"styles_closeIcon__4opQ6","background":"styles_background__zY0UR"};

/***/ }),

/***/ 20061:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__kEMzF","thead":"styles_thead__fliSZ","tbody":"styles_tbody__I_tl_","tbodyDesktop":"styles_tbodyDesktop__O8MUw","firstColumnDesktop":"styles_firstColumnDesktop__jQjwi"};

/***/ })

}]);